import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  "enable-background": "new 0 0 24 24",
  version: "1.1",
  viewBox: "0 0 24 24",
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "m19.46 15.128c-1.0425 0.3225-2.175 0.2025-3.1275-0.3375-0.1875-0.1125-0.36-0.2325-0.525-0.375-0.3525-0.3525-0.8925-0.435-1.3425-0.2175-0.735 0.27-1.515 0.405-2.3025 0.3825-1.5375 0.0075-2.9475-0.84-3.6525-2.205-0.2775-0.4875-0.48-1.02-0.7725-1.5-0.7725-1.29-1.8375-1.5075-3.0825-0.6525-0.4125 0.285-0.8025 0.705-1.3425 0.72-0.42 0.045-0.8325-0.1425-1.0725-0.4875-0.1875-0.3075-0.345-1.29-0.15-1.215 0.105 0.0375 0.045 0.7125 0.45 0.9675 0.3675 0.24 0.8475 0.1725 1.1325-0.1575 0.285-0.27 0.5175-0.48 0.8175-0.735 0.72-0.615 1.725-0.7875 2.61-0.45 1.0725 0.435 1.4625 1.425 2.07 2.25 1.2525 1.635 3.5325 2.085 5.3175 1.035 0.1725-0.1275 0.3-0.3075 0.36-0.5175 1.0875-2.445 4.9425-2.91 6.6075-0.8025 0.8475 1.0425 0.69 2.58-0.3525 3.435-0.0525 0.045-0.1125 0.0825-0.165 0.1275-0.435 0.345-0.9375 0.5925-1.4775 0.735z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }